"use strict";
var Utilities = (function () {
    function Utilities() {
    }
    Utilities.appendTrailingSlash = function (url) {
        return url.charAt(url.length - 1) === "/" ? url : url + "/";
    };
    return Utilities;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Utilities;



//////////////////
// WEBPACK FOOTER
// ./Base/Utilities.js
// module id = 15
// module chunks = 0